// ─────────────────────────────────────────────────────────────
//  Projectsdata.ts  —  updated with Renovations/Construction
//  category rename + 7 ongoing projects from the PCI profile
// ─────────────────────────────────────────────────────────────

// ── Electrical ──────────────────────────────────────────────
import Globe1  from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag1.png";
import Globe2  from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag2.png";
import Globe3  from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag3.png";
import Globe4  from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag4.png";
import Globe5  from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag5.png";
import Globe6  from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag6.png"; 
import Globe7  from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag7.png";
import Globe8  from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag8.png";
import Globe9  from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag9.png";
import Globe10 from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag10.png";
import Globe11 from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag11.png";
import Globe12 from "./CompletedProjects/GlobeBaliuag/GlobeBaliuag12.png";

import Aviation1 from "./CompletedProjects/1AVIATION/1AVIATION1.png";
import Aviation2 from "./CompletedProjects/1AVIATION/1AVIATION2.png";
import Aviation3 from "./CompletedProjects/1AVIATION/1AVIATION3.png";
import Aviation4 from "./CompletedProjects/1AVIATION/1AVIATION4.png";

// ── Gaisano Mactan ──────────────────────────────────────────
import Gaisano1  from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart1.jpg";
import Gaisano2  from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart2.jpg";
import Gaisano3  from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart3.jpg";
import Gaisano4  from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart4.jpg";
import Gaisano5  from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart5.jpg";
import Gaisano6  from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart6.jpg";
import Gaisano7  from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart7.jpg";
import Gaisano8  from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart8.jpg";
import Gaisano9  from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart9.jpg";
import Gaisano10 from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart10.jpg";
import Gaisano11 from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart11.jpg";
import Gaisano12 from "./CompletedProjects/GaisanoMactan/GaisanoMactanSmart12.jpg";

// ── NCDC Ormoc ──────────────────────────────────────────────
import NCDC1 from "./CompletedProjects/NCDCORMOC/NCDC1.png";
import NCDC2 from "./CompletedProjects/NCDCORMOC/NCDC2.png";
import NCDC3 from "./CompletedProjects/NCDCORMOC/NCDC3.png";
import NCDC4 from "./CompletedProjects/NCDCORMOC/NCDC4.png";
import NCDC5 from "./CompletedProjects/NCDCORMOC/NCDC5.png";
import NCDC6 from "./CompletedProjects/NCDCORMOC/NCDC6.png";

// ── Ongoing — import the images you'll place in the
//    /src/OngoingProjects/ folder (copy from PPTX exports)
// ────────────────────────────────────────────────────────────
//  Mindoro Occidental Cooperative Hospital
import Mindoro1 from "./CompletedProjects/MOCHMC/MOCHMC1.png";
import Mindoro2 from "./CompletedProjects/MOCHMC/MOCHMC2.png";
import Mindoro3 from "./CompletedProjects/MOCHMC/MOCHMC3.png";

//  POI Festoon — San Andres, Catanduanes
import SanAndres1 from "./CompletedProjects/PoiFestonSanAndres/PoiFestonSanAndres1.png";
import SanAndres2 from "./CompletedProjects/PoiFestonSanAndres/PoiFestonSanAndres2.png";
import SanAndres3 from "./CompletedProjects/PoiFestonSanAndres/PoiFestonSanAndres3.png";

//  Badoc POI Festoon
import Badoc1 from "./CompletedProjects/BADOC/Badoc1.png";
import Badoc2 from "./CompletedProjects/BADOC/Badoc2.png";

//  BTP2 NaOH Dozing System
import BTP1 from "./CompletedProjects/BT2P/BT2P1.png";
import BTP2 from "./CompletedProjects/BT2P/BT2P2.png";
import BTP3 from "./CompletedProjects/BT2P/BT2P3.png";

import Elem1 from "./CompletedProjects/SanFernandoElementarySchool/1.jpg";
import Elem2 from "./CompletedProjects/SanFernandoElementarySchool/2.jpg";
import Elem3 from "./CompletedProjects/SanFernandoElementarySchool/3.jpg";
import Elem4 from "./CompletedProjects/SanFernandoElementarySchool/4.jpg";
import Elem5 from "./CompletedProjects/SanFernandoElementarySchool/5.jpg";
import Elem6 from "./CompletedProjects/SanFernandoElementarySchool/6.jpg";
import Elem7 from "./CompletedProjects/SanFernandoElementarySchool/7.jpg";

import AyalaCebuSmart1 from "./CompletedProjects/AyalaCebu/AyalaCebuSmart1.png";
import AyalaCebuSmart2 from "./CompletedProjects/AyalaCebu/AyalaCebuSmart2.png";
import AyalaCebuSmart3 from "./CompletedProjects/AyalaCebu/AyalaCebuSmart3.png";
import AyalaCebuSmart4 from "./CompletedProjects/AyalaCebu/AyalaCebuSmart4.png";
import AyalaCebuSmart5 from "./CompletedProjects/AyalaCebu/AyalaCebuSmart5.png";
import AyalaCebuSmart6 from "./CompletedProjects/AyalaCebu/AyalaCebuSmart6.png";
import AyalaCebuSmart7 from "./CompletedProjects/AyalaCebu/AyalaCebuSmart7.png";
import AyalaCebuSmart8 from "./CompletedProjects/AyalaCebu/AyalaCebuSmart8.png";

import CardonaRizal1 from "./CompletedProjects/CardonaRizal/CardonaRizal1.png";
import CardonaRizal2 from "./CompletedProjects/CardonaRizal/CardonaRizal2.png";
import CardonaRizal3 from "./CompletedProjects/CardonaRizal/CardonaRizal3.png";
import CardonaRizal4 from "./CompletedProjects/CardonaRizal/CardonaRizal4.png";

import GlobeCalbayog1 from "./CompletedProjects/GlobeCalbayog/1.jpg";
import GlobeCalbayog12 from "./CompletedProjects/GlobeCalbayog/12.jpg";
import GlobeCalbayog16 from "./CompletedProjects/GlobeCalbayog/16.jpg";

import GlobeMaasin1 from "./CompletedProjects/GlobeMaasin/GlobeMaasin1.png";
import GlobeMaasin4 from "./CompletedProjects/GlobeMaasin/GlobeMaasin4.png";
import GlobeMaasin5 from "./CompletedProjects/GlobeMaasin/GlobeMaasin5.png";

import Model1 from "./CompletedProjects/ModelUnitsDasma/ModelUnit1.png";
import Model2 from "./CompletedProjects/ModelUnitsDasma/ModelUnit2.png";

import PetronBohol1 from "./CompletedProjects/PetronBohol/PetronBohol1.png";
import PetronBohol2 from "./CompletedProjects/PetronBohol/PetronBohol2.png";
import PetronBohol3 from "./CompletedProjects/PetronBohol/PetronBohol3.png";

import pldtcdo1 from "./CompletedProjects/pldtcdo/pldtcdo1.png";
import pldtcdo2 from "./CompletedProjects/pldtcdo/pldtcdo2.png";
import pldtcdo3 from "./CompletedProjects/pldtcdo/pldtcdo3.png";

import PLDTCotabato1 from "./CompletedProjects/PLDTCotabato/PLDTCotabato1.png";
import PLDTCotabato2 from "./CompletedProjects/PLDTCotabato/PLDTCotabato2.png";
import PLDTCotabato3 from "./CompletedProjects/PLDTCotabato/PLDTCotabato3.png";
import PLDTCotabato4 from "./CompletedProjects/PLDTCotabato/PLDTCotabato4.png";

import RobinsonIliganSmart1 from "./CompletedProjects/RobinsonsIligan/RobinsonIliganSmart1.jpg";
import RobinsonIliganSmart8 from "./CompletedProjects/RobinsonsIligan/RobinsonIliganSmart8.jpg";
import RobinsonIliganSmart9 from "./CompletedProjects/RobinsonsIligan/RobinsonIliganSmart9.jpg";

import SanjosMarket1 from "./CompletedProjects/SanjosMarket/SanjosMarket1.jpg";
import SanjosMarket2 from "./CompletedProjects/SanjosMarket/SanjosMarket2.jpg";
import SanjosMarket3 from "./CompletedProjects/SanjosMarket/SanjosMarket3.jpg";

import SMLegaspiSmart1 from "./CompletedProjects/SMLegaspi/SMLegaspiSmart1.jpg";
import SMLegaspiSmart4 from "./CompletedProjects/SMLegaspi/SMLegaspiSmart4.jpg";
import SMLegaspiSmart7 from "./CompletedProjects/SMLegaspi/SMLegaspiSmart7.jpg";

import WaterTankCalamba1 from "./CompletedProjects/WaterTankCalamba/WaterTankCalamba1.png";
import WaterTankCalamba2 from "./CompletedProjects/WaterTankCalamba/WaterTankCalamba2.png";

import WaterTankPampanga1 from "./CompletedProjects/WaterTankPampanga/WaterTankPampanga1.png";
import WaterTankPampanga2 from "./CompletedProjects/WaterTankPampanga/WaterTankPampanga2.png";







// ─────────────────────────────────────────────────────────────
export interface ProjectData {
  id:          number;
  title:       string;
  category:    string;
  cover:       string;
  images:      string[];
  description: string;
  location?:   string;
  client?:     string;
  completion?: string;
  amount?:     string;
  ongoing?:    boolean;
}

export interface CategoryGroup {
  label:    string;
  projects: ProjectData[];
}

// ─────────────────────────────────────────────────────────────
//  ALL PROJECTS
// ─────────────────────────────────────────────────────────────
export const ALL_PROJECTS: ProjectData[] = [

  // ── Electrical ──────────────────────────────────────────
  {
    id: 1,
    title: "Globe Baliuag",
    category: "Electrical",
    cover: Globe1,
    images: [Globe1, Globe2, Globe3, Globe4, Globe5, Globe6,
             Globe7, Globe8, Globe9, Globe10, Globe11, Globe12],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Baliuag, Bulacan",
    client: "Globe Telecom",
  },
  {
    id: 2,
    title: "Gaisano Mactan — Smart Store Development",
    category: "Renovations/Construction",
    cover: Gaisano1,
    images: [Gaisano1, Gaisano2, Gaisano3, Gaisano4, Gaisano5, Gaisano6,
             Gaisano7, Gaisano8, Gaisano9, Gaisano10, Gaisano11, Gaisano12],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Mactan, Cebu",
    client: "PLDT / Smart",
  },

  // ── Civil Works ─────────────────────────────────────────
  {
    id: 3,
    title: "New Core Data Center",
    category: "Civil Works",
    cover: NCDC1,
    images: [NCDC1, NCDC2, NCDC3, NCDC4, NCDC5, NCDC6,],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Brgy. Bantique, Ormoc City, Leyte",
    client: "Globe",
  },

  // ── Renovations / Construction ───────────────────────────
  {
    id: 4,
    title: "1Aviation Office Fit-Out",
    category: "Renovations/Construction",
    cover: Aviation1,
    images: [Aviation1, Aviation2, Aviation3, Aviation4],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Along Domestic Road, Pasay City",
    client: "1Aviation",
  },
  {
    id: 5,
    title: "San Fernando Elementary School",
    category: "Civil Works",
    cover: Elem5,
    images: [Elem1, Elem2, Elem3, Elem4, Elem5, Elem6, Elem7],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "San Fernando, Pampanga",
    client: "San Fernando City Government",
  },
  {
    id: 6,
    title: "Model Units - Dasmariñas",
    category: "Civil Works",
    cover: Model1,
    images: [Model1, Model2],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Dasmariñas, Cavite",
    client: "ASK",
  },
  {
    id: 7,
    title: "Chemical Tanks - Cardona, Rizal",
    category: "Civil Works",
    cover: CardonaRizal1,
    images: [CardonaRizal1, CardonaRizal2, CardonaRizal3, CardonaRizal4],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Cardona, Rizal",
    client: "Manila Water Company Inc.",
  },
  {
    id: 9 ,
    title: "Petron Bohol",
    category: "Civil Works",
    cover: PetronBohol3,
    images: [PetronBohol1, PetronBohol2, PetronBohol3],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Tagbilaran City, Bohol",
    client: "Petron Corporation",
  },
  {
    id: 10,
    title: "Sanjos Market",
    category: "Civil Works",
    cover: SanjosMarket1,
    images: [SanjosMarket1, SanjosMarket2, SanjosMarket3],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Tala, Caloocan",
    client: "PA Properties",
  },
  {
    id: 11,
    title: "Water Tank - Calamba",
    category: "Civil Works",
    cover: WaterTankCalamba1,
    images: [WaterTankCalamba1, WaterTankCalamba2],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Averdeen Estate, Nuvali, Calamba",
    client: "????",
  },
  {
    id: 12,
    title: "Water Tank - Pampanga",
    category: "Civil Works",
    cover: WaterTankPampanga1,
    images: [WaterTankPampanga1, WaterTankPampanga2],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Deca Homes, Clark, Pampanga",
    client: "BPWI",
  },
  {
    id: 13,
    title: "Globe Calbayog",
    category: "Electrical",
    cover: GlobeCalbayog1,
    images: [GlobeCalbayog1, GlobeCalbayog12, GlobeCalbayog16],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Calbayog, Samar",
    client: "Globe Telecom",
  },
  {
    id: 14,
    title: "Globe Maasin",
    category: "Electrical",
    cover: GlobeMaasin1,
    images: [GlobeMaasin1, GlobeMaasin4, GlobeMaasin5],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Maasin, Leyte",
    client: "Globe Telecom",
  },
  {
    id: 15,
    title: "Ayala Cebu Smart",
    category: "Renovations/Construction",
    cover: AyalaCebuSmart1,
    images: [AyalaCebuSmart1, AyalaCebuSmart2, AyalaCebuSmart3, AyalaCebuSmart4, AyalaCebuSmart5, AyalaCebuSmart6, AyalaCebuSmart7, AyalaCebuSmart8],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Cebu City, Cebu",
    client: "Ayala Corporation",
  },
  {
    id: 16,
    title: "PLDT CDO",
    category: "Renovations/Construction",
    cover: pldtcdo1,
    images: [pldtcdo1, pldtcdo2, pldtcdo3],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Cagayan De Oro, Mindanao",
    client: "PLDT",
  },
  {
    id: 17,
    title: "PLDT Cotabato",
    category: "Renovations/Construction",
    cover: PLDTCotabato1,
    images: [PLDTCotabato1, PLDTCotabato2, PLDTCotabato3, PLDTCotabato4],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Cagayan De Oro, Mindanao",
    client: "PLDT",
  },
  {
    id: 18,
    title: "Smart Robinsons Iligan",
    category: "Renovations/Construction",
    cover: RobinsonIliganSmart9,
    images: [RobinsonIliganSmart9, RobinsonIliganSmart1, RobinsonIliganSmart8],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Iligan City, Mindanao",
    client: "Smart Communications",
  },
  {
    id: 19,
    title: "SM Legaspi Smart",
    category: "Renovations/Construction",
    cover: SMLegaspiSmart1,
    images: [SMLegaspiSmart1, SMLegaspiSmart4, SMLegaspiSmart7],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Cagayan De Oro, Mindanao",
    client: "PLDT",
  },
  // ── Ongoing ─────────────────────────────────────────────
  {
    id: 101,
    title: "Mindoro Occidental Cooperative Hospital",
    category: "Ongoing",
    cover: Mindoro1,
    images: [Mindoro1, Mindoro2, Mindoro3],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Sitio San Carlos, San Jose, Mindoro Occidental",
    ongoing: true,
  },
  {
    id: 102,
    title: "POI Festoon — San Andres, Catanduanes",
    category: "Ongoing",
    cover: SanAndres1,
    images: [SanAndres1, SanAndres2, SanAndres3],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "San Andres, Catanduanes",
    ongoing: true,
  },
  {
    id: 103,
    title: "Badoc POI Festoon Project",
    category: "Ongoing",
    cover: Badoc1,
    images: [Badoc1, Badoc2],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Brgy. Mabajao, Maasin City, Leyte",
    ongoing: true,
  },
  {
    id: 104,
    title: "BTP2 Centralized NaOH Dozing System",
    category: "Ongoing",
    cover: BTP1,
    images: [BTP1, BTP2, BTP3],
    description: "TEMPORARY DESCRIPTION: Waiting for the actual project description from PCI.",
    location: "Pansol, Quezon City",
    client: "Manila Water Company Inc.",
    ongoing: true,
  },
];

// ── Featured on home page (pick best visual projects) ───────
export const FEATURED_PROJECTS = ALL_PROJECTS.filter(p =>
  [18, 17, 16, 15].includes(p.id)
);

// ── Category groups for Projects page ───────────────────────
export const CATEGORIES: CategoryGroup[] = [
 
  {
    label: "Civil Works",
    projects: ALL_PROJECTS.filter(p => p.category === "Civil Works"),
  },
  {
    label: "Electrical",
    projects: ALL_PROJECTS.filter(p => p.category === "Electrical"),
  },
  {
    label: "Renovations / Construction",
    projects: ALL_PROJECTS.filter(p => p.category === "Renovations/Construction"),
  },
   {
    label: "Ongoing Projects",
    projects: ALL_PROJECTS.filter(p => p.category === "Ongoing"),
  },
];